import React, { useEffect, useState, useRef, useCallback } from "react";
import { couple, local } from "../../assets/imgs";
import JoditEditor from "jodit-react";
import { configJodit, GOOGLE_MAP_KEY } from "../../screens/redux/api/Constants";
import SelectBox from "../SelectBox";
import {
  useLazyPropertyContentListQuery,
  useMinimumAgeMutation,
  useNewTotalLocationsListMutation,
  usePropertyRoomDetailsAddMutation,
} from "../../screens/redux/api/api";
import GoogleMapPage from "../../screens/MapTest/GoogleMap";
import { Spinner } from "react-bootstrap";


const CustomerOptionsAdd = ({ valueType, formData, setFormData }) => {
  // Location dropdown states
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(false)

  const [ageList, setAgeList] = useState([]);

  const [validation, setValidation] = useState("");


  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };



  // RTK Query
  const [getCountryListApi] = useNewTotalLocationsListMutation();
  const [minimumAgeListApi] = useMinimumAgeMutation();
  const [propertyContentListApi] = useLazyPropertyContentListQuery();

  const getAge = (type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    minimumAgeListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("age_list", res);
        setAgeList(res?.categories);
      })
      .catch((err) => {
        console.log("age_err", err);
      });
  };

  const getCountry = (type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    setLoader(true)
    getCountryListApi(formdata)
      .unwrap()
      .then((res) => {
        setCountryList(res?.data || []);
        if (res?.data[0]?.name) {
          setLoader(false);
        }

      })
      .catch((err) => {
        console.error(err);
        setLoader(false)
      }).finally(() => {
        setLoader(false);
      })
  };




  const getList = () => {
    setLoader(true)
    propertyContentListApi()
      .unwrap()
      .then((res) => {
        if (res?.status == 'success') {
          let list = res?.data?.filter((item) => item?.policy_type == 4);
          setList(list || []);
          setLoader(false)
        }
      })
      .catch((err) => {
        console.error(err);
        setLoader(false)
      })
  }

  console.log('list', list)
  useEffect(() => {
    getCountry(1);
    getAge(2);
    getList()
  }, []);

  const handleLocationChange = (id, type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    formdata.append("parent_id", id);
    setLoader(true);
    getCountryListApi(formdata)
      .unwrap()
      .then((res) => {
        if (type === 2) {
          // State
          setStateList(res?.data || []);
          setCityList([]);
          setAreaList([]);
          setFormData((prev) => ({
            ...prev,
            state_id: null,
            city_id: null,
            area_id: null,
          }));
          setLoader(false)
        } else if (type === 3) {
          // City
          setCityList(res?.data || []);
          setAreaList([]);
          setFormData((prev) => ({
            ...prev,
            city_id: null,
            area_id: null,
          }));
          setLoader(false)
        } else if (type === 4) {
          // Area
          setAreaList(res?.data || []);
          setFormData((prev) => ({
            ...prev,
            area_id: null,
          }));
          setLoader(false);
        }
      })
      .catch((err) => {
        console.error(err);
      }).finally(() => {
        setLoader(false);
      })

  };

  // When country is selected, load states
  useEffect(() => {
    if (formData.country_id) {
      handleLocationChange(formData.country_id, 2);
    }
  }, [formData.country_id]);

  // When state is selected, load cities
  useEffect(() => {
    if (formData.state_id) {
      handleLocationChange(formData.state_id, 3);
    }
  }, [formData.state_id]);

  // When city is selected, load areas
  useEffect(() => {
    if (formData.city_id) {
      handleLocationChange(formData.city_id, 4);
    }
  }, [formData.city_id]);

  const handlePricingChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      pricing: {
        ...prev.pricing,
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    if (formData.check_in) {
      const [hours, minutes] = formData.check_in.split(":").map(Number);
      const checkInDate = new Date();
      checkInDate.setHours(hours);
      checkInDate.setMinutes(minutes);

      // Add 22 hours
      checkInDate.setHours(checkInDate.getHours() + 22);

      const hh = String(checkInDate.getHours()).padStart(2, "0");
      const mm = String(checkInDate.getMinutes()).padStart(2, "0");

      const checkOutTime = `${hh}:${mm}`;

      setFormData((prev) => ({
        ...prev,
        check_out: checkOutTime,
      }));
    }
  }, [formData.check_in]);

  return (
    <div className="mt-3">
      <div className="d-flex gap-5 mb-4">
        <div className="col-md-5">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Check In Time
          </h4>
          <input
            type="time"
            className="input-pop ps-2 w-100"
            value={formData.check_in}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, check_in: e.target.value }))
            }
          />
        </div>
        <div className="col-md-5">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Check Out Time
          </h4>
          <input
            type="time"
            className="input-pop ps-2 w-100"
            value={formData.check_out}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, check_out: e.target.value }))
            }
            disabled={true}
          />
        </div>
      </div>

      {valueType !== 2 && (
        <>
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Pricing Per Day
          </h4>
          <div className="input-pop_box">
            <table className="w-100">
              <thead>
                <tr className="text-center">
                  <th>Monday</th>
                  <th>Tuesday</th>
                  <th>Wednesday</th>
                  <th>Thursday</th>
                  <th>Friday</th>
                  <th>Saturday</th>
                  <th>Sunday</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  {[
                    "mon_price",
                    "tue_price",
                    "wed_price",
                    "thu_price",
                    "fri_price",
                    "sat_price",
                    "sun_price",
                  ].map((day) => (
                    <td key={day} className="col-md-1">
                      <input
                        className="input-pop w-80 mt-2 mb-2 text-center"
                        name={day}
                        value={formData.pricing[day]}
                        onChange={handlePricingChange}
                        placeholder={"Enter Amount"}
                        type="number"
                        maxLength={5}
                        min={0}
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          <div className="d-flex flex-wrap gap-3 my-5">
            <div className="col-md-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Total Person Count
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                value={formData.total_person_count}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    total_person_count: e.target.value,
                  }))
                }
                placeholder="Total Person Count"
              />
            </div>
            <div className="col-md-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Extra Person Count
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                value={formData.extra_person_count}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    extra_person_count: e.target.value,
                  }))
                }
                placeholder="Extra Person Count"
              />
            </div>
            <div className="col-md-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Extra Charges Per Person
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                value={formData.extra_charges_per_person}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    extra_charges_per_person: e.target.value,
                  }))
                }
                placeholder="Extra Charges Per Person"
              />
            </div>
          </div>
        </>
      )}

      <div className="my-4">
        <div className="col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Minimum Age
          </h4>

          {/* <input
            type="number"
            className="input-pop ps-2 w-100"
            value={formData.age_category_id}
            onChange={(e) => setFormData(prev => ({ ...prev, age_category_id: e.target.value }))}
            placeholder="20"
          /> */}

          <select
            type="date"
            className="input-pop ps-2 w-100"
            placeholder="Select type"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                age_category_id: e.target.value,
              }))
            }
          >
            <option value="">Select Age category</option>
            {ageList.map((item, ind) => {
              return (
                <option value={item?.id} key={item?.id}>
                  {item?.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
        Customer Option
      </h4>
      <div className="d-flex gap-5 mb-4">
        <div className="col-md-5 d-flex ac-js gap-5">
          <div className="input-pop p-2">
            <button className="d-flex ac-jc gap-3 cust-btn w-100">
              <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary flex-nowrap">
                Couple Friendly
              </p>
              <img src={couple} alt="" className="tub-img" />
            </button>
          </div>
          <div className="d-flex ac-js gap-3">
            <button
              className={`cust-btn w-100 ${formData.is_couple_friendly === 1 ? "recep-yes" : "recep-no"
                }`}
              onClick={() =>
                setFormData((prev) => ({ ...prev, is_couple_friendly: 1 }))
              }
            >
              Yes
            </button>
            <button
              className={`cust-btn w-100 ${formData.is_couple_friendly === 0 ? "recep-yes" : "recep-no"
                }`}
              onClick={() =>
                setFormData((prev) => ({ ...prev, is_couple_friendly: 0 }))
              }
            >
              No
            </button>
          </div>
        </div>

        <div className="col-md-5 d-flex ac-js gap-5">
          <div className="input-pop p-2">
            <button className="d-flex ac-jc gap-3 cust-btn w-100">
              <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                Local ID Allowed
              </p>
              <img src={local} alt="" className="tub-img" />
            </button>
          </div>
          <div className="d-flex ac-js gap-3">
            <button
              className={`cust-btn w-100 ${formData.is_local_id_allowed === 1 ? "recep-yes" : "recep-no"
                }`}
              onClick={() =>
                setFormData((prev) => ({ ...prev, is_local_id_allowed: 1 }))
              }
            >
              Yes
            </button>
            <button
              className={`cust-btn w-100 ${formData.is_local_id_allowed === 0 ? "recep-yes" : "recep-no"
                }`}
              onClick={() =>
                setFormData((prev) => ({ ...prev, is_local_id_allowed: 0 }))
              }
            >
              No
            </button>
          </div>
        </div>
      </div>

      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
        Location
      </h4>
      <div className="d-flex mt-3 ac-jb flex-wrap">
        <div className="d-flex ac-js gap-2 col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Country
          </h4>
          <SelectBox
            array_list={countryList}
            value_text={formData.country_name || ""}
            setvalue_text={(name) =>
              setFormData((prev) => ({
                ...prev,
                country_name: name,
                state_id: "",
                state_name: "",
                city_name: "",
                city_id: "",
                area_id: "",
                area_name: "",
              }))
            }
            value_id={formData.country_id}
            setvalue_id={(id) =>
              setFormData((prev) => ({ ...prev, country_id: id }))
            }
            placeholder_text="Select Country"
            isMulti={false}
            isTextArea={false}
            code={"code"}
            setValidation={setValidation}
          />
        </div>

        <div className="d-flex ac-js gap-2 col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 ms-1">
            State
          </h4>
          <SelectBox
            array_list={stateList}
            value_text={formData.state_name || ""}
            setvalue_text={(name) => {
              setFormData((prev) => ({
                ...prev,
                state_name: name,
                city_name: "",
                city_id: "",
                area_id: "",
                area_name: "",
              }));
            }}
            value_id={formData.state_id}
            setvalue_id={(id) =>
              setFormData((prev) => ({ ...prev, state_id: id }))
            }
            placeholder_text={"Select State"}
            isMulti={false}
            isTextArea={false}
            disabled={!formData.country_id}
            code={"code"}
            setValidation={setValidation}
          />
        </div>

        <div className="d-flex ac-js gap-2 col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 ms-1">
            City
          </h4>
          <SelectBox
            array_list={cityList}
            value_text={formData.city_name || ""}
            setvalue_text={(name) =>
              setFormData((prev) => ({
                ...prev,
                city_name: name,
                area_id: "",
                area_name: "",
              }))
            }
            value_id={formData.city_id}
            setvalue_id={(id) =>
              setFormData((prev) => ({ ...prev, city_id: id }))
            }
            placeholder_text={"Select City"}
            isMulti={false}
            isTextArea={false}
            disabled={!formData.state_id}
            code={"code"}
            setValidation={setValidation}
          />
        </div>

        <div className="d-flex ac-js gap-2 col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 ms-1">
            Area
          </h4>
          <SelectBox
            array_list={areaList}
            value_text={formData.area_name || ""}
            setvalue_text={(name) =>
              setFormData((prev) => ({ ...prev, area_name: name }))
            }
            value_id={formData.area_id}
            setvalue_id={(id) =>
              setFormData((prev) => ({ ...prev, area_id: id }))
            }
            placeholder_text={"Select Area"}
            isMulti={false}
            isTextArea={false}
            disabled={!formData.city_id}
            code={"code"}
            setValidation={setValidation}
          />
        </div>
      </div>

      <div className="mt-5 ">
        <GoogleMapPage setFormData={setFormData} formData={formData} />
        <div className="d-flex justify-content-between mt-3">
          <div className="col-md-4">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Latitude
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              value={formData.latitude}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, latitude: e.target.value }))
              }
              placeholder="Enter Latitude"
              disabled
            />
          </div>
          <div className="col-md-4">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Longitude
            </h4>
            <input
              type="number"
              className="input-pop ps-2 w-100"
              value={formData.longitude}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, longitude: e.target.value }))
              }
              placeholder="Enter Longitude"
              disabled
            />
          </div>
        </div>
        <div className="w-100 mt-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Address
          </h4>
          <textarea
            className="input-pop ps-2 w-100"
            value={formData.address}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, address: e.target.value }))
            }
            placeholder="Address"
            style={{
              height: "100px",
            }}
          />
        </div>
      </div>

      <div className="d-flex ac-jb mb-3">
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
          Description
        </h4>
        <select
          className="input-pop ps-2 mx-3 w-50"
          onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
          value={formData.description}
        >
          <option value="">Select Description</option>
          {list.map((item) => (
            <option key={item.id} value={item.description}>
              {item.description.length > 32
                ? `${stripHtml(item.description).substring(0, 32)}...`
                : <p>{stripHtml(item.description)}</p>}
            </option>
          ))}

        </select>
      </div>
      <JoditEditor
        style={{ border: "1px solid #0C3A2D" }}
        className="input-pop w-100"
        value={formData.description}
        config={configJodit}
        onBlur={(newContent) =>
          setFormData((prev) => ({ ...prev, description: newContent }))
        }
      />
      {loader && (<div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
        <Spinner animation="border" className="primary1" />
      </div>
      )}
    </div>
  );
};

export default CustomerOptionsAdd;
